// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1FuPY","imageUploader":"EGiftCard_imageUploader__2uRPc"};